module.exports = __webpack_public_path__ + "img/time-cog-grey-outline.e22a8037.svg";